// NAV-2026-10-22: the CRM's nav, eight items. Every text, email and chat lives on the person's timeline, open threads in
// Needs a human, and Today lists what needs action -- so the views that used to be tabs of their own now sit under one of
// the eight, as a filter row at the top of it. Their view ids are kept, so every deep link (an alert's "Open", Today's
// "Open", a push notification) still lands where it did; the nav lights the item they now live under.
//   Retired (audited first, see tools/reports/NAV-2026-10-22.md): Dashboard, Pipeline, Jobs, Messaging, Inbox, Formspree.

/** The nav, in order: Today first (a phone opens on it). */
export const NAV = [
  { id: 'today', label: 'Today' },
  { id: 'leads', label: 'Leads' },
  { id: 'candidates', label: 'Candidates' },
  { id: 'facilities', label: 'Facilities' },
  { id: 'needs', label: 'Needs a human' },
  { id: 'reports', label: 'Reports' },
  { id: 'activity', label: 'Activity' },
  { id: 'settings', label: 'Settings' },
];

/** A view that moved -> the nav item it lives under. */
export const NAV_PARENT = { conversations: 'needs', drafts: 'needs', alerts: 'needs', reviews: 'needs', onboarding: 'candidates', expirations: 'candidates', duplicates: 'candidates', reminders: 'today' };

/** The views that are gone; a link to one lands on its replacement (Reminders folded into Today). */
export const RETIRED = { dashboard: 'today', pipeline: 'candidates', jobs: 'candidates', messaging: 'needs', inbox: 'needs', formspree: 'leads', reminders: 'today' };

/** The view a request for `view` shows: a retired one becomes its replacement; anything else is itself. */
export const resolveView = (view) => RETIRED[view] || view;

/** The nav item lit for a view. */
export const navOf = (view) => NAV_PARENT[resolveView(view)] || resolveView(view);

/** Needs a human's filter row, in order: the people waiting, every conversation, drafts to approve, system alerts. */
export const NEEDS_FILTERS = [
  { id: 'needs', label: 'Needs a human' },
  { id: 'conversations', label: 'Conversations' },
  { id: 'drafts', label: 'Drafts' },
  { id: 'alerts', label: 'System alerts' },
  { id: 'reviews', label: 'Reviews' },        // NIGHT-DIRECTSTAFF-2026-10-23 §1: submitted reviews to approve / reject
];

/** Candidates: two sub-tabs, and (under List) the filters -- the four that only Dashboard used to reach, and expirations. */
export const CANDIDATE_TABS = [{ id: 'candidates', label: 'List' }, { id: 'onboarding', label: 'Onboarding' }];
export const CANDIDATE_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'hot', label: 'Hot' },
  { id: 'active', label: 'Active contracts' },
  { id: 'overdue', label: 'Overdue follow-ups' },
  { id: 'ending', label: 'Ending soon' },
  { id: 'expirations', label: 'Expiring credentials' },   // the Expirations view, as a filter
  { id: 'duplicates', label: 'Possible duplicates' },     // NIGHT-DIRECTSTAFF-2026-10-29 §1: the Duplicates view, as a filter
];
